export default "__VITE_ASSET__D0CdLBRT__"